import { render, staticRenderFns } from "./decannulation.vue?vue&type=template&id=08273c4e&scoped=true"
import script from "./decannulation.vue?vue&type=script&lang=js"
export * from "./decannulation.vue?vue&type=script&lang=js"
import style0 from "./decannulation.vue?vue&type=style&index=0&id=08273c4e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08273c4e",
  null
  
)

export default component.exports